import { is } from '@babel/types';
import React, { useEffect, useRef, useState } from 'react';

const GeneralizedModal = ({ setIsModalOpen, academyData, isModalOpen, dataSectionToRender, studentProfile, selectedStudentIdRef }) => {
    if (!isModalOpen) {
        return null;
    }
    const onClose = () => {
        setIsModalOpen(false);
    }
    let dataSections = null;
    if (dataSectionToRender.current === "student") {
        let thisStudent = selectedStudentIdRef.current;
        console.log(thisStudent);
        dataSections = academyData.current.studentProfile[thisStudent];
        console.log(dataSections);
    } else if (dataSectionToRender.current === "tutor") {
        dataSections = academyData.current.tutorTableData;
    } else if (dataSectionToRender.current === "classStatistics") {
        dataSections = academyData.current.classStatisticsFinal;
    } else if (dataSectionToRender.current === "classTable") {
        dataSections = academyData.current.classTableFinal;
    } else if (dataSectionToRender.current === "graphData") {
        console.log(academyData.current.graphData);
        dataSections = academyData.current.graphData;
    } else if (dataSectionToRender.current === "forecast") {
        dataSections = academyData.current.forecastFinal;
    }
    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="close-button" onClick={() => { onClose(); }}>✖</button>
                <div>{dataSections}</div>
            </div>
        </div>
    );
};

export default GeneralizedModal;